/* global width:true */
/* eslint no-undef: "error" */

import React from "react";
import { SocialShare } from "@quintype/components";
import { object, array, string, func } from "prop-types";

import MetypeCommentWrapper from "../../metype-comments";
import StoryMetaInfo from "../../molecules/story-meta-info";
import CardImage from "../../atoms/card-image";
import Demarcation from "../../atoms/demarcation";
import StickySocialShareTemplate from "../../molecules/sticky-social-share";
import StoryCard from "../story-card";
import StoryTag from "../story-tag";
import SideBar from "../side-bar";
import RelatedStories from "../related-stories";
import LightBox from "../../molecules/lightbox";
import Adsense from "../../adsense";

import { createImageElement, storyShareClickHandler } from "../../utils";

import "./blank.m.css";

class BlankStoryTemplate extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      renderMetype: false,
      showReadmore: {},
      wrapperClass: "",
      addReadmore: false,
      width: null,
      showPopup: false,
      element: null
    };
  }

  togglePopup = () => {
    this.setState({
      showPopup: !this.state.showPopup,
      element: this.state.showPopup ? null : createImageElement(this.props.story)
    });
  };

  isWidthPresent = () => {
    this.setState({ width });
  };

  componentDidMount() {
    this.isWidthPresent();

    this.setState({
      renderMetype: true
    });
  }

  render() {
    const { story, recentStories, collectionName, trendingStories, config } = this.props;
    const { showPopup, element } = this.state;
    const publisherUrl = config["sketches-host"] || "https://www.freepressjournal.in";

    return (
      <React.Fragment>
        <div styleName="wrapper">
          <div>
            <StoryMetaInfo story={story} />
            <div styleName="card-image">
              {story["hero-image-s3-key"] && (
                <div onClick={this.togglePopup}>
                  <CardImage story={story} defaultWidth={760} aspectRatio={[16, 9]} imageType="image16x9" isStoryPage />
                </div>
              )}
            </div>
            <div styleName="image-attribute">
              {story["hero-image-caption"] && (
                <figcaption className="story-element-image-title">{story["hero-image-caption"]}</figcaption>
              )}
              {story["hero-image-attribution"] && (
                <figcaption className="story-element-image-attribution">{story["hero-image-attribution"]}</figcaption>
              )}
            </div>
            <div styleName="dfp-ad2-728x90">
              {this.state.width <= 992 && (
                <div styleName="dfp-ad-300x100">
                  <Adsense adSlotId="3689255812" width="300" height="250" />
                </div>
              )}
              {this.state.width >= 992 && <Adsense adSlotId="5135370519" width="720" height="90" />}
            </div>
            <div styleName="story-content">
              <div>
                <SocialShare
                  template={StickySocialShareTemplate}
                  title={story.headline}
                  url={story.slug}
                  color="#000"
                  sticky
                  onClick={storyShareClickHandler(story["story-content-id"], `${publisherUrl}/${story.slug}`)}
                />
              </div>
              <div styleName="blank-story-content">
                <div ref={divElement => (this.divElement = divElement)}>
                  <div styleName="content-wrapper">
                    {story.cards.map((card, index) => {
                      return (
                        <React.Fragment key={card.id}>
                          {index !== 0 &&
                            index % 3 === 0 && (
                              <div styleName="dfp-ad2-728x90">
                                <Adsense adSlotId="5135370519" width="720" height="90" />
                              </div>
                            )}
                          {<StoryCard key={card.id} card={card} story={story} />}
                        </React.Fragment>
                      );
                    })}
                    <div styleName="dfp-ad2-728x90">
                      <Adsense adSlotId="5135370519" width="720" height="90" />
                    </div>

                    <StoryTag tags={story.tags} />
                    {this.state.renderMetype && <MetypeCommentWrapper story={story} />}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <SideBar stories={recentStories} collectionName={collectionName} id={story.id} />
          </div>
        </div>
        <div styleName="related-stories">
          <RelatedStories relatedStories={trendingStories} collectionName="trending" />
          <div id={`${story.slug}`} />
        </div>
        {showPopup ? <LightBox element={element} closePopup={() => this.togglePopup()} /> : null}
      </React.Fragment>
    );
  }
}

function BlankStory(props) {
  return (
    <div className="story-grid">
      <BlankStoryTemplate
        story={props.story}
        trendingStories={props.trendingStories}
        collectionName={props.collectionName}
        recentStories={props.recentStories}
        config={props.config}
      />
      <Demarcation />
    </div>
  );
}

BlankStoryTemplate.propTypes = {
  story: object,
  trendingStories: array,
  collectionName: string,
  recentStories: array,
  config: func
};

BlankStory.propTypes = {
  story: object,
  trendingStories: array,
  collectionName: string,
  recentStories: array,
  config: func
};

export default BlankStory;
